import { useCallback, useContext } from 'react';
import GoalsContext from '../../../../../../contexts/GoalsContext';
import usesFieldInPlates from './usesFieldInPlates';

const useGetFieldGoalUsage = () => {
  const { goals } = useContext(GoalsContext);
  const getFieldGoalUsage = useCallback(
    (field: string, dataset: string) => {
      return goals.filter((goal) => {
        return goal.kpis.some((kpi) => {
          return usesFieldInPlates(kpi.drillDowns, field, dataset);
        });
      });
    },
    [goals],
  );

  return getFieldGoalUsage;
};

export default useGetFieldGoalUsage;
